import { useEffect, useState, useRef } from "react";
import { Card } from "react-bootstrap";
import CountUp from "react-countup";

export const AcademicExcellence = () => {
  const data = [
    { count: 64, title: " Educational Institutions under the P.E. Society" },
    { count: 150, title: "Industry Collaborations at MIBM" },
    { count: 2500, title: "Distinguished Alumni Network at MIBM" },
    { count: 30, title: "Expert Faculty Members at MIBM" },
  ];

  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);
  const [visible, setVisible] = useState(false); // for fade-in

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const top = sectionRef.current.getBoundingClientRect().top;
      const bottom = sectionRef.current.getBoundingClientRect().bottom;
      const windowHeight = window.innerHeight;

      // Check if section is at least partially in viewport
      if (top < windowHeight && bottom > 0) {
        setStartCount(true);
        setVisible(true);
      } else {
        // Reset if section is out of view
        setStartCount(false);
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // check on mount

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div ref={sectionRef} className="excellence-container">
      <h2 className="excellence">91 Years of Academic Excellence – Progressive Education Society</h2>
      <h6 style={{ fontSize: "22px"}}>Guided by Modern Educational Values and Progressive Ideals</h6>

      <div className="card-container">
        {data.map((item, index) => (
          <Card
            key={index}
            className={`excellence-card fade-in ${visible ? "visible" : ""} p-4 m-3`}
          >
            <h2 className="excellence-count">
              {startCount ? <CountUp end={item.count} duration={2} /> : 0}+
            </h2>
            <h4 className="excellence-title">{item.title}</h4>
          </Card>
        ))}
      </div>
    </div>
  );
};
